//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'dashboard-container-item',
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number
  },
  data: function data() {
    return {};
  },
  computed: {
    gridLayout: function gridLayout() {
      if (this.widget.widgetList.length <= 0) {
        return [{
          x: 0,
          y: 0,
          w: 4,
          h: 4,
          i: '0'
        }];
      } else {
        return this.widget.options.layout;
      }
    }
  },
  methods: {
    onRefresh: function onRefresh(item) {
      this.$set(item.options, 'isRefresh', !item.options.isRefresh);
    }
  }
};